import React from 'react';
import { useTranslation } from 'react-i18next';
import { OMEGA3_DIFFERENCE_ITEMS } from '../data/omega3Data';

const Omega3DifferenceSection = () => {
  const { t } = useTranslation();

  return (
    <section className="t-bg-navy t-py-16 md:t-py-20">
      <div className="container !t-max-w-[1200px]">
        <div className="t-mb-10 t-text-center">
          <h2
            className="!t-m-0 t-text-[28px] lg:t-text-[42px] t-leading-[1.08] t-text-white"
            style={{ fontFamily: 'DM Serif Display, serif' }}
          >
            {t('Omega3_Difference_Title')}
          </h2>
          <p className="t-mx-auto t-mt-3 t-max-w-[760px] t-text-base lg:t-text-lg t-leading-[1.6] t-text-white/75">
            {t('Omega3_Difference_Subtitle')}
          </p>
        </div>

        <div className="t-grid t-grid-cols-1 lg:t-grid-cols-2 t-gap-5">
          {OMEGA3_DIFFERENCE_ITEMS.map((item) => (
            <article
              key={item.titleKey}
              className="t-rounded-[16px] t-border t-border-white/10 t-bg-white/[0.07] t-p-6 md:t-p-7"
            >
              <div className="t-flex t-items-center t-gap-2">
                <span className="t-inline-flex t-h-9 t-w-9 t-items-center t-justify-center t-rounded-full t-bg-butter t-text-sm t-font-[800] t-text-navy">
                  {item.number}
                </span>
                <span className="t-inline-flex t-rounded-full t-bg-butter t-px-2.5 t-py-1 t-text-xs t-font-[800] t-leading-none t-text-navy">
                  {t(item.eyebrowKey)}
                </span>
              </div>
              <h3 className="t-mt-4 t-text-lg lg:t-text-xl t-font-[800] t-leading-[1.2] t-text-white">
                {t(item.titleKey)}
              </h3>
              <p className="t-mt-2.5 t-text-sm lg:t-text-base t-leading-[1.65] t-text-white/80">
                {t(item.bodyKey)}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Omega3DifferenceSection;
